import { IBaseOWClassDescription, IPublicAttributeInfo } from "@multiweb/types/contracts";
import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";

/**
 * Klient poskytující přístup k informacím o modelu
 * @includeToDoc
 */
export interface IModelDescriptionsClient {

    /**
     * Získá informace o třídě
     * @param className Třída, pro kterou se informace získávají
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    getClassInfo(className: string, cancellationToken?: CancellationToken): Promise<IBaseOWClassDescription>;

    /**
     * Získá veřejné informace o atributu
     * @param className Třída atributu
     * @param attributes Pole atributů, pro které se informace získávají
     * @param cancellationToken Umožňuje zrušit běžící dotaz
     */
    getAttributesPublicInfo(className: string, attributes: ReadonlyArray<string>, cancellationToken?: CancellationToken): Promise<ReadonlyArray<IPublicAttributeInfo>>;
}
